import React from 'react';
import { viewGenAIView as ViewGenAIView } from './viewGenAIView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';

class ViewGenAIComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRequirement: true,
      parsedRequirement: [],
      selectedRecord: null,
      requirementRadio: 'TestData',
      dataVal: '',
      isLoading: false,
      selectedProvider: 'openai',
      selectedModel: "gpt-4.1",
      llmModels: {},
      totalRecords: 0,
      currentPage: 0,
      pageLimit: 10
    };
  }

  componentDidMount() {
    // Landing on Historical Data is a fresh entry point (including after
    // switching tabs/projects). Drop any stale edit context so Create New — or
    // a direct return here — never reopens a previously edited record.
    sessionStorage.removeItem('checkId');
    const TestDataManagement = localStorage.getItem('TestDataManagement');
    const TestCheck = sessionStorage.getItem('TestCheck');
    this.fetchLlmConfig();
    if (TestDataManagement === 'true' && TestCheck === 'TestData') {
      this.setState({dataVal: 'TestData'}, () => this.viewData());
    } else {
      this.setState({ dataVal: 'TestDesign'}, () => this.viewData());
    }
  }

  pageChangeData = (data, currentPage, pageLimit) => {
    this.setState({
      currentPage,
      pageLimit,
      parsedRequirement: data
    });

    this.viewData(currentPage, pageLimit);
  };

  handleChangellm = (e) => {
    const [provider, model] = e.target.value.split("|");
    this.setState({
      selectedProvider: provider,
      selectedModel: model
    });
  };

  fetchLlmConfig = () => {
    const token = localStorage.getItem('AceToken');
      const orgId = localStorage.getItem('OrgId');
      const aceBackendUrl = localStorage.getItem('AceBackendUrl');
      // this.setState({ isLoadingButton: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.LLM_CONFIG,
        requestBody: { token, orgId, aceBackendUrl },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const { defaultLlmProvider, llmModels } = payload;
            const providerModels = llmModels?.[defaultLlmProvider] || {};
            const defaultModel = Object.keys(providerModels)[0] || '';
            this.setState({
              selectedProvider: defaultLlmProvider,
              selectedModel: defaultModel,
              llmModels
            });

          } else {
            this.setState({ errorMessage: 'Failed to fetch LLM configuration', openErrorModal: true});
          }
        }
      });
  }

  viewData = (id, limit) => {
    const { pageLimit, dataVal } = this.state;
    const pageNumber = id || 0;
    const pageSize = limit || pageLimit;
    const userEmail = localStorage.getItem('email');
    const projectId = localStorage.getItem('ProjectId');
    this.setState({isLoading: true});
    fetch.get({
      // url: `${APP.Constants.SERVICE_URLS.GET_GPT_DATA}${dataVal}/${userEmail}/${pageNumber}/${pageSize}`,
      url: `${APP.Constants.SERVICE_URLS.GET_GPT_DATA + dataVal}/projectId/${projectId || 'All'}/${pageNumber}/${pageSize}`,
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (status === APP.Constants.SUCCESS) {
          this.setState({
            parsedRequirement: payload?.content || [],
            selectedRecord:
              payload?.content && payload.content.length
                ? payload.content[0]
                : null,
            totalRecords: payload?.totalElements,
            currentPage: payload?.number,
            requirementRadio: dataVal,
            isLoading: false
          });
        } else {
          this.setState({
            parsedRequirement: [],
            selectedRecord: null,
            isLoading: false
          });
        }
      }
    });
  };

  onRecordSelect = (record) => {
    this.setState({
      selectedRecord: record
    });
  };

  getLeftPanelTitle = (item) => {
  const isValid = (value) =>
    value !== null &&
    value !== undefined &&
    String(value).trim() !== '' &&
    String(value).trim().toLowerCase() !== 'null';
 
  let title = `TC${item.id}`;
 
  if (isValid(item.jiraId)) {
    title += `(${item.jiraId})`;
  }
 
  if (isValid(item.tcName)) {
    title += `: ${item.tcName}`;
  }
 
  return title;
};
  onEditClicked = (eve, item) => {
    sessionStorage.setItem('checkId', JSON.stringify(item));
    localStorage.setItem('selectedProvider', this.state.selectedProvider);
    localStorage.setItem('selectedModel', this.state.selectedModel);
    this.props.goToPage(APP.Constants.ROUTES.TEST_CONFIG);
  };
  onAddClicked = () => {
    // Create New must start a fresh record. Clear any 'checkId' left behind by a
    // previous Edit, otherwise Test Design opens in edit mode with the old test
    // cases (and they leak across projects).
    sessionStorage.removeItem('checkId');
    this.props.goToPage(APP.Constants.ROUTES.TEST_CONFIG);
  };

  render() {
    return (
      <ViewGenAIView
        {...this.state}
        onRecordSelect={this.onRecordSelect}
        onEditClicked={this.onEditClicked}
        onAddClicked={this.onAddClicked}
        changeData={this.pageChangeData}
        handleChangellm={this.handleChangellm}
        fetchLlmConfig={this.fetchLlmConfig}
        getLeftPanelTitle={this.getLeftPanelTitle}

      />
    );
  }
}

export default ViewGenAIComponent;